import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, RotateCcw, Smartphone } from "lucide-react";
import { StandFace } from "./Stand3D";

const Screen = ({ tapped, stars }) => (
  <div data-testid="demo-phone-screen" className="absolute inset-[6px] rounded-[30px] bg-white overflow-hidden">
    <motion.div animate={{ opacity: tapped ? 0 : 1 }} className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 bg-[#0B1120] text-white">
      <p className="font-mono text-[10px] uppercase tracking-widest text-[#A8DCF2]">09:41</p>
      <p className="mt-3 text-sm text-slate-300">Apropie telefonul de stand</p>
    </motion.div>
    <motion.div initial={false} animate={{ y: tapped ? 0 : "100%" }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} className="absolute inset-0 p-4 flex flex-col">
      <p className="text-[11px] text-slate-500">g.page / review</p>
      <p className="mt-4 font-semibold text-sm">Cafeneaua Ta</p>
      <p className="text-[11px] text-slate-500">Lasă o recenzie publică</p>
      <div className="mt-5 flex gap-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <motion.span key={i} animate={{ scale: i < stars ? [1, 1.35, 1] : 1 }} transition={{ duration: 0.35 }}>
            <Star className={`w-6 h-6 transition-colors duration-200 ${i < stars ? "fill-[#F59E0B] text-[#F59E0B]" : "text-slate-300"}`} />
          </motion.span>
        ))}
      </div>
      <div className="mt-5 rounded-lg border border-slate-200 p-2.5 text-[11px] text-slate-600 min-h-[70px]">
        {stars === 5 ? "Servire excelentă, revin cu drag!" : ""}
      </div>
      <div className={`mt-auto rounded-full py-2 text-center text-xs font-semibold transition-colors ${stars === 5 ? "bg-[#1A73E8] text-white" : "bg-slate-100 text-slate-400"}`}>Publică</div>
    </motion.div>
  </div>
);

export const TapDemo = () => {
  const [tapped, setTapped] = useState(false);
  const [stars, setStars] = useState(0);

  useEffect(() => {
    if (!tapped) { setStars(0); return undefined; }
    const timers = [1, 2, 3, 4, 5].map((n) => setTimeout(() => setStars(n), 700 + n * 180));
    return () => timers.forEach(clearTimeout);
  }, [tapped]);

  return (
    <div data-testid="demo-simulator-section" className="relative rounded-[32px] bg-[#E3F2FA] border border-white p-6 sm:p-10 overflow-hidden">
      <div className="relative h-[420px] sm:h-[460px] flex items-end justify-center">
        <div className="absolute left-[2%] sm:left-[12%] bottom-6 w-[150px] sm:w-[180px] aspect-[3/4] -rotate-3 shadow-[0_30px_60px_-30px_rgba(31,111,153,0.6)] rounded-[22px]">
          <StandFace compact />
        </div>
        <motion.div
          animate={tapped ? { x: -40, y: 30, rotate: -14 } : { x: 20, y: 0, rotate: 6 }}
          transition={{ type: "spring", stiffness: 90, damping: 16 }}
          className="absolute right-[4%] sm:right-[12%] bottom-10 w-[170px] sm:w-[190px] h-[340px] sm:h-[380px] rounded-[36px] bg-[#0B1120] shadow-[0_40px_80px_-30px_rgba(11,17,32,0.7)]"
        >
          <Screen tapped={tapped} stars={stars} />
        </motion.div>
      </div>
      <div className="relative mt-6 flex justify-center">
        <motion.button whileTap={{ scale: 0.96 }} data-testid="demo-tap-button" onClick={() => setTapped((t) => !t)} className="inline-flex items-center gap-2 rounded-full bg-[#0B1120] text-white px-6 py-3 text-sm hover:bg-[#1F6F99] transition-colors">
          {tapped ? <><RotateCcw className="w-4 h-4" /> Reîncearcă</> : <><Smartphone className="w-4 h-4" /> Atinge standul cu telefonul</>}
        </motion.button>
      </div>
    </div>
  );
};
